import { useState, useEffect } from 'react';
import { doc, onSnapshot, updateDoc, increment } from 'firebase/firestore';

export const useCreditSystem = (user, db) => {
  const [credits, setCredits] = useState({ remaining: 0, limit: 0, isPro: false, loading: true });

  useEffect(() => {
    if (!user || !db) return;

    // Listen to the user document in real-time
    const unsub = onSnapshot(doc(db, 'users', user.uid), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setCredits({
          remaining: data.creditsRemaining !== undefined ? data.creditsRemaining : 5,
          limit: data.monthlyLimit || 5, // Default 5 for free tier
          isPro: data.isPro || false,
          loading: false
        });
      } else {
        // Initialize new user doc if it doesn't exist - this case might be handled elsewhere (e.g., on signup)
        // but good to have a fallback state locally
        setCredits({ remaining: 5, limit: 5, isPro: false, loading: false });
      }
    });

    return () => unsub();
  }, [user, db]);

  // Helper to deduct credits atomically
  const deductCredit = async (cost = 1) => {
    if (!user || !db) return false;
    const userRef = doc(db, 'users', user.uid);
    try {
        await updateDoc(userRef, {
            creditsRemaining: increment(-cost)
        });
        return true;
    } catch (error) {
        console.error("Error deducting credit:", error);
        return false;
    }
  };

  return { ...credits, deductCredit };
};